<div class="vi-program-item flex flex-row gap-[18px]">
  <div
    *ngIf="displayProgramTile"
    class="flex flex-row justify-start flex-[14px] min-w-[14px] max-w-[14px]"
    [ngClass]="hasTemperature ? 'items-start' : 'items-center'"
  >
    <div class="program {{ program }} flex-1" [class.centered]="hasTemperature"></div>
  </div>
  <div [ngStyle]="{ display: 'block' }">
    <ng-content select="[name]"></ng-content>
    <ng-content select="[item]"></ng-content>
  </div>
</div>
